import $ from 'jquery';
import Swal from 'sweetalert2';

export function initChatAssistant() {
    const chatForm = document.getElementById('chatForm');
    const chatInput = document.getElementById('chatInput');
    const chatContainer = document.getElementById('chatContainer');
    const btnSend = document.getElementById('btnSend');
    const btnStop = document.getElementById('btnStop');
    const activeModelIndicator = document.getElementById('activeModelIndicator');
    const modelSelector = document.getElementById('modelSelector');
    const modelDropdownToggle = document.getElementById('modelDropdownToggle');
    const modelDropdown = document.getElementById('modelDropdown');
    const chatModelName = document.getElementById('chatModelName');
    const btnNewChat = document.getElementById('btnNewChat');

    // Sidebar Toggle Elements
    const chatSidebar = document.getElementById('chatSidebar');
    const btnSidebarToggle = document.getElementById('btnSidebarToggle');
    const btnSidebarClose = document.getElementById('btnSidebarClose');

    if (!chatForm || !chatInput || !chatContainer) return;

    // Mobile Sidebar Logic
    if (btnSidebarToggle && chatSidebar) {
        btnSidebarToggle.addEventListener('click', () => {
            chatSidebar.classList.add('open');
        });
    }
    if (btnSidebarClose && chatSidebar) {
        btnSidebarClose.addEventListener('click', () => {
            chatSidebar.classList.remove('open');
        });
    }

    // TTS Toggle Logic
    window.isTTSEnabled = true; // Default ON
    const btnToggleTTS = document.getElementById('btnToggleTTS');
    if (btnToggleTTS) {
        btnToggleTTS.addEventListener('click', function() {
            window.isTTSEnabled = !window.isTTSEnabled;
            if (window.isTTSEnabled) {
                this.classList.add('active');
                this.style.color = '#10a37f';
                this.style.borderColor = '#10a37f';
                this.title = 'Auto-baca Suara (Aktif)';
            } else {
                this.classList.remove('active');
                this.style.color = 'var(--chat-text-secondary)';
                this.style.borderColor = 'var(--chat-border)';
                this.title = 'Auto-baca Suara (Nonaktif)';
                if ('speechSynthesis' in window) {
                    window.speechSynthesis.cancel();
                }
            }
        });
    }

    const chatMessagesWrapper = document.getElementById('messagesList') || chatContainer;

    let currentPurpose = 'chat';
    let selectedModelId = '';
    let currentAbortController = null;

    if (btnStop) {
        btnStop.addEventListener('click', function() {
            if (currentAbortController) {
                currentAbortController.abort();
            }
        });
    }

    // ── Model Dropdown Toggle ───────────────────────────────────────────
    if (modelDropdownToggle && modelDropdown) {
        modelDropdownToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = modelDropdown.classList.contains('show');
            modelDropdown.classList.toggle('show');
            modelDropdownToggle.classList.toggle('open');
        });

        // Close dropdown on outside click
        document.addEventListener('click', function(e) {
            if (!modelDropdownToggle.contains(e.target) && !modelDropdown.contains(e.target)) {
                modelDropdown.classList.remove('show');
                modelDropdownToggle.classList.remove('open');
            }
        });

        // Model selection from dropdown items
        const dropdownItems = modelDropdown.querySelectorAll('.chat-model-dropdown-item');
        dropdownItems.forEach(item => {
            item.addEventListener('click', function() {
                // Remove active from all
                dropdownItems.forEach(di => di.classList.remove('active'));
                this.classList.add('active');

                selectedModelId = this.getAttribute('data-model-id');
                const label = this.getAttribute('data-model-label');

                // Update header name
                if (chatModelName) {
                    chatModelName.textContent = label;
                }

                // Sync hidden select for backward compatibility
                if (modelSelector) {
                    modelSelector.value = selectedModelId;
                }

                // Close dropdown
                modelDropdown.classList.remove('show');
                modelDropdownToggle.classList.remove('open');
            });
        });
    }

    // ── Suggestion Chips (Welcome Cards) ────────────────────────────────
    const suggestionChips = document.querySelectorAll('.chat-welcome-card, .chat-suggestion-chip');
    suggestionChips.forEach(chip => {
        chip.addEventListener('click', function() {
            const prompt = this.getAttribute('data-prompt');
            if (prompt) {
                chatInput.value = prompt;
                chatInput.dispatchEvent(new Event('input'));
                chatForm.dispatchEvent(new Event('submit'));
            }
        });
    });

    // ── Context Sidebar Clicks ──────────────────────────────────────────
    const contextItems = document.querySelectorAll('.chat-context-item');
    contextItems.forEach(item => {
        item.addEventListener('click', function() {
            const key = this.getAttribute('data-key');
            if (key) {
                chatInput.value = `Berikan rangkuman / analisis dari data ${key}`;
                chatInput.dispatchEvent(new Event('input'));
                chatForm.dispatchEvent(new Event('submit'));

                // Auto-close sidebar on mobile after clicking
                if (window.innerWidth <= 768 && chatSidebar) {
                    chatSidebar.classList.remove('open');
                }
            }
        });
    });

    // ── New Chat Button ─────────────────────────────────────────────────
    if (btnNewChat) {
        btnNewChat.addEventListener('click', function() {
            // Clear messages
            chatMessagesWrapper.innerHTML = '';

            // Show welcome screen
            const welcomeContainer = document.getElementById('welcomeContainer');
            if (welcomeContainer) {
                welcomeContainer.style.removeProperty('display');
            }

            // Reset indicator
            if (activeModelIndicator) {
                activeModelIndicator.innerHTML = '<span class="chat-status-dot"></span> Ready';
                activeModelIndicator.className = 'chat-status-badge';
            }

            chatInput.focus();
        });
    }

    // ── Auto-resize Textarea ────────────────────────────────────────────
    chatInput.addEventListener('input', function() {
        this.style.height = 'auto';
        const maxH = 160;
        this.style.height = (this.scrollHeight < maxH ? this.scrollHeight : maxH) + 'px';
    });

    chatInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            chatForm.dispatchEvent(new Event('submit'));
        }
    });

    // ── Append Message ──────────────────────────────────────────────────
    function appendMessage(text, isUser = false, modelInfo = null) {
        const wrapper = document.createElement('div');
        wrapper.className = 'chat-message ' + (isUser ? 'user-message' : 'assistant-message');

        const bubble = document.createElement('div');
        bubble.className = 'chat-message-bubble';

        const markdownParser = window.marked || { parse: (t) => t };
        let parsedText = isUser ? escapeHtml(text) : markdownParser.parse(text);

        if (isUser) {
            bubble.innerHTML = `<div class="chat-user-content">${parsedText}</div>`;
        } else {
            let metaHtml = '';
            if (modelInfo) {
                metaHtml = `
                    <div class="chat-message-meta">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                        <span>${modelInfo}</span>
                    </div>
                `;
            }
            bubble.innerHTML = `
                <div class="chat-assistant-content message-content">${parsedText}</div>
                ${metaHtml}
            `;
        }

        wrapper.appendChild(bubble);
        chatMessagesWrapper.appendChild(wrapper);

        // Render Chart.js blocks if present
        if (!isUser) {
            const chartBlocks = bubble.querySelectorAll('pre code.language-chart');
            chartBlocks.forEach((codeEl, index) => {
                try {
                    const chartConfig = JSON.parse(codeEl.textContent.trim());
                    if (!chartConfig.options) chartConfig.options = {};
                    chartConfig.options.responsive = true;
                    chartConfig.options.maintainAspectRatio = true;
                    
                    // Force white background for the canvas to avoid transparent downloads
                    const bgColorPlugin = {
                        id: 'customCanvasBackgroundColor',
                        beforeDraw: (chart, args, options) => {
                            const {ctx} = chart;
                            ctx.save();
                            ctx.globalCompositeOperation = 'destination-over';
                            ctx.fillStyle = options.color || '#1e1e2d'; // match dark mode bg
                            ctx.fillRect(0, 0, chart.width, chart.height);
                            ctx.restore();
                        }
                    };

                    // Plugin for Data Labels (drawing values directly on the chart)
                    const dataLabelsPlugin = {
                        id: 'alwaysShowDataLabels',
                        afterDatasetsDraw: function(chart, args, options) {
                            const ctx = chart.ctx;
                            chart.data.datasets.forEach((dataset, i) => {
                                const meta = chart.getDatasetMeta(i);
                                if (!meta.hidden) {
                                    meta.data.forEach((element, index) => {
                                        ctx.fillStyle = '#adb5bd';
                                        const fontSize = 11;
                                        const fontStyle = 'bold';
                                        const fontFamily = 'sans-serif';
                                        ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                                        
                                        const dataString = dataset.data[index].toString();
                                        
                                        ctx.textAlign = 'center';
                                        ctx.textBaseline = 'middle';

                                        const padding = 5;
                                        const position = element.tooltipPosition();
                                        
                                        // Position text above the bar/point
                                        ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding);
                                    });
                                }
                            });
                        }
                    };

                    if (!chartConfig.plugins) chartConfig.plugins = [];
                    chartConfig.plugins.push(bgColorPlugin);
                    chartConfig.plugins.push(dataLabelsPlugin);

                    const container = document.createElement('div');
                    container.className = 'chat-chart-container';
                    // Apply a specific background if we want the downloaded image to have it
                    container.style.backgroundColor = '#1e1e2d';
                    container.style.padding = '16px';
                    container.style.borderRadius = '12px';
                    container.style.marginTop = '12px';
                    container.style.border = '1px solid var(--chat-border)';

                    const canvas = document.createElement('canvas');
                    canvas.style.maxHeight = '240px';
                    container.appendChild(canvas);

                    // Add Actions (Download & Share)
                    const actionsDiv = document.createElement('div');
                    actionsDiv.className = 'chat-chart-actions';
                    actionsDiv.style.display = 'flex';
                    actionsDiv.style.gap = '8px';
                    actionsDiv.style.marginTop = '16px';
                    actionsDiv.style.justifyContent = 'flex-end';

                    // Download Button
                    const btnDownload = document.createElement('button');
                    btnDownload.className = 'btn btn-sm btn-outline-secondary';
                    btnDownload.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> Download`;
                    btnDownload.onclick = () => {
                        const link = document.createElement('a');
                        link.download = `Chart_Analisis_${new Date().getTime()}.png`;
                        link.href = canvas.toDataURL('image/png', 1.0);
                        link.click();
                    };

                    // WhatsApp Share Button
                    const btnWa = document.createElement('button');
                    btnWa.className = 'btn btn-sm btn-success';
                    btnWa.style.backgroundColor = '#25D366';
                    btnWa.style.borderColor = '#25D366';
                    btnWa.style.color = 'white';
                    btnWa.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg> Share WA`;
                    btnWa.onclick = async () => {
                        canvas.toBlob(async (blob) => {
                            const file = new File([blob], 'Chart_Analisis.png', { type: 'image/png' });
                            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                                try {
                                    await navigator.share({
                                        title: 'Grafik Analisis AI',
                                        text: 'Berikut adalah grafik analisis operasional dari AI Kilat Assistant.',
                                        files: [file]
                                    });
                                } catch (error) {
                                    console.log('Share canceled or failed', error);
                                }
                            } else {
                                // Fallback: copy to clipboard
                                try {
                                    await navigator.clipboard.write([
                                        new ClipboardItem({ 'image/png': blob })
                                    ]);
                                    Swal.fire('Disalin!', 'Gambar berhasil disalin ke Clipboard. Silakan "Paste" di WhatsApp Anda.', 'success');
                                } catch (err) {
                                    Swal.fire('Oops!', 'Peramban ini tidak mendukung share otomatis. Silakan klik Download terlebih dahulu.', 'info');
                                }
                            }
                        }, 'image/png');
                    };

                    actionsDiv.appendChild(btnDownload);
                    actionsDiv.appendChild(btnWa);
                    container.appendChild(actionsDiv);

                    const pre = codeEl.parentNode;
                    pre.parentNode.replaceChild(container, pre);

                    if (window.Chart) {
                        new window.Chart(canvas, chartConfig);
                    }
                } catch (err) {
                    console.error('Failed to render chart:', err);
                }
            });
        }

        chatContainer.scrollTop = chatContainer.scrollHeight;
    }

    function escapeHtml(unsafe) {
        return unsafe
             .replace(/&/g, "&amp;")
             .replace(/</g, "&lt;")
             .replace(/>/g, "&gt;")
             .replace(/"/g, "&quot;")
             .replace(/'/g, "&#039;");
    }

    // ── Typing Indicator ────────────────────────────────────────────────
    function showTypingIndicator() {
        const div = document.createElement('div');
        div.className = 'chat-typing';
        div.id = 'typingIndicator';
        div.innerHTML = `
            <div class="chat-typing-dot"></div>
            <div class="chat-typing-dot"></div>
            <div class="chat-typing-dot"></div>
        `;
        chatMessagesWrapper.appendChild(div);
        chatContainer.scrollTop = chatContainer.scrollHeight;
    }

    function removeTypingIndicator() {
        const indicator = document.getElementById('typingIndicator');
        if (indicator) indicator.remove();
    }

    // ── Form Submit ─────────────────────────────────────────────────────
    chatForm.addEventListener('submit', async function(e) {
        e.preventDefault();

        const message = chatInput.value.trim();
        if (!message) return;

        // Reset input
        chatInput.value = '';
        chatInput.style.height = 'auto';

        // Hide welcome
        const welcomeContainer = document.getElementById('welcomeContainer');
        if (welcomeContainer) {
            welcomeContainer.style.setProperty('display', 'none', 'important');
        }

        // Append User Message
        appendMessage(message, true);

        // Show typing
        showTypingIndicator();
        btnSend.disabled = true;
        btnSend.style.display = 'none';
        if (btnStop) btnStop.style.display = 'flex';

        currentAbortController = new AbortController();

        try {
            const baseUrl = window.appBaseUrl || '';
            const sendUrl = baseUrl ? `${baseUrl}/chat-assistant/send` : '/chat-assistant/send';

            const response = await fetch(sendUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="X-CSRF-TOKEN"]')?.getAttribute('content')
                },
                body: JSON.stringify({
                    message: message,
                    purpose: currentPurpose,
                    model_id: selectedModelId || (modelSelector ? modelSelector.value : '')
                }),
                signal: currentAbortController.signal
            });

            const data = await response.json();
            removeTypingIndicator();

            if (response.ok && data.reply) {
                if (activeModelIndicator) {
                    activeModelIndicator.innerHTML = `<span class="chat-status-dot"></span> ${data.provider} (${data.model})`;
                    activeModelIndicator.className = 'chat-status-badge';
                }
                appendMessage(data.reply, false, `${data.provider} — ${data.model}`);

                // ── Auto-read voice (TTS) ──
                if (window.isTTSEnabled && 'speechSynthesis' in window) {
                    // Stop any ongoing speech
                    window.speechSynthesis.cancel();
                    
                    // Basic Markdown strip to make reading cleaner
                    const rawText = data.reply.replace(/[\#\*\`\~_\[\]\>\!]/g, '').replace(/\(http[^\)]+\)/g, '');
                    const utterance = new SpeechSynthesisUtterance(rawText);
                    utterance.lang = 'id-ID';
                    window.speechSynthesis.speak(utterance);
                }
            } else {
                if (activeModelIndicator) {
                    activeModelIndicator.innerHTML = 'Error';
                    activeModelIndicator.className = 'chat-status-badge status-error';
                }

                let rawMsg = data.message || data.error || 'Terjadi kesalahan pada AI Provider.';
                let cleanMsg = 'Sistem AI sedang mengalami gangguan atau kuota batas tercapai. Silakan coba kembali beberapa saat lagi.';
                let swalTitle = 'Terjadi Kesalahan';

                if (rawMsg.includes('429') || rawMsg.toLowerCase().includes('rate limit')) {
                    swalTitle = 'Batas Kuota Tercapai';
                    const match = rawMsg.match(/try again in ([\d\.]+\s*s?)/i);
                    if (match && match[1]) {
                        cleanMsg = `Batas limit penggunaan AI tercapai. Silakan coba kembali dalam ${match[1].replace('s', ' detik')}.`;
                    } else if (rawMsg.includes('maksimal 5')) {
                        cleanMsg = rawMsg;
                    } else {
                        cleanMsg = 'Batas limit penggunaan AI tercapai. Silakan coba kembali beberapa saat lagi.';
                    }
                } else if (rawMsg.includes('400') || rawMsg.toLowerCase().includes('decommissioned')) {
                    cleanMsg = 'Model AI yang dikonfigurasi tidak didukung atau telah dinonaktifkan. Silakan periksa pengaturan model AI Anda.';
                } else if (rawMsg.includes('401') || rawMsg.toLowerCase().includes('api key')) {
                    cleanMsg = 'Kunci API (API Key) AI tidak valid. Silakan periksa konfigurasi API Key Anda.';
                }

                Swal.fire({
                    icon: 'error',
                    title: swalTitle,
                    text: cleanMsg,
                    confirmButtonColor: '#10a37f',
                    confirmButtonText: 'Tutup'
                });
            }
        } catch (error) {
            removeTypingIndicator();
            
            if (error.name === 'AbortError') {
                if (activeModelIndicator) {
                    activeModelIndicator.innerHTML = '<span class="chat-status-dot"></span> Ready';
                    activeModelIndicator.className = 'chat-status-badge';
                }
                return;
            }

            if (activeModelIndicator) {
                activeModelIndicator.innerHTML = 'Disconnected';
                activeModelIndicator.className = 'chat-status-badge status-error';
            }

            Swal.fire({
                icon: 'error',
                title: 'Koneksi Gagal',
                text: 'Maaf, gagal terhubung ke server AI. Silakan coba beberapa saat lagi.',
                confirmButtonColor: '#10a37f',
                confirmButtonText: 'Tutup'
            });
        } finally {
            btnSend.disabled = false;
            btnSend.style.display = 'flex';
            if (btnStop) btnStop.style.display = 'none';
            currentAbortController = null;
            chatInput.focus();
        }
    });

    // ── Scroll to Bottom Button ─────────────────────────────────────────
    const scrollBtn = document.createElement('button');
    scrollBtn.className = 'chat-scroll-bottom';
    scrollBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>';
    scrollBtn.setAttribute('aria-label', 'Scroll to bottom');
    document.getElementById('chatApp').appendChild(scrollBtn);

    chatContainer.addEventListener('scroll', function() {
        const distFromBottom = this.scrollHeight - this.scrollTop - this.clientHeight;
        if (distFromBottom > 200) {
            scrollBtn.classList.add('visible');
        } else {
            scrollBtn.classList.remove('visible');
        }
    });

    scrollBtn.addEventListener('click', function() {
        chatContainer.scrollTo({ top: chatContainer.scrollHeight, behavior: 'smooth' });
    });

    // ── Voice Input (Speech-to-Text) with Silence Detection + Auto-Send ──
    const btnVoice = document.getElementById('btnVoice');
    if (btnVoice) {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (SpeechRecognition) {
            const recognition = new SpeechRecognition();
            recognition.lang = 'id-ID';
            recognition.interimResults = true;
            recognition.continuous = true;
            recognition.maxAlternatives = 1;

            let isListening = false;
            let finalTranscript = '';
            let interimTranscript = '';
            let autoSendTimer = null;
            let countdownInterval = null;
            let countdownSeconds = 3;
            let silenceTimer = null;
            const SILENCE_TIMEOUT = 2000; // 2 seconds of silence → auto-stop
            const COUNTDOWN_DURATION = 3;  // 3 second countdown before send

            const iconMic = btnVoice.querySelector('.voice-icon-mic');
            const iconStop = btnVoice.querySelector('.voice-icon-stop');

            // Create countdown badge element
            const countdownBadge = document.createElement('div');
            countdownBadge.className = 'voice-countdown-badge';
            countdownBadge.innerHTML = '<span class="voice-countdown-number">3</span><span class="voice-countdown-label">Mengirim...</span>';
            countdownBadge.style.display = 'none';
            const chatInputContainer = document.querySelector('.chat-input-container');
            if (chatInputContainer) {
                chatInputContainer.insertBefore(countdownBadge, chatInputContainer.firstChild);
            }

            function clearSilenceTimer() {
                if (silenceTimer) {
                    clearTimeout(silenceTimer);
                    silenceTimer = null;
                }
            }

            function resetSilenceTimer() {
                clearSilenceTimer();
                if (isListening && finalTranscript.trim()) {
                    silenceTimer = setTimeout(function () {
                        // User hasn't spoken for 2 seconds — auto-stop recording
                        if (isListening) {
                            recognition.stop();
                        }
                    }, SILENCE_TIMEOUT);
                }
            }

            function cancelAutoSend() {
                if (autoSendTimer) {
                    clearTimeout(autoSendTimer);
                    autoSendTimer = null;
                }
                if (countdownInterval) {
                    clearInterval(countdownInterval);
                    countdownInterval = null;
                }
                countdownBadge.style.display = 'none';
                countdownBadge.classList.remove('active');
            }

            function startAutoSendCountdown() {
                cancelAutoSend();
                
                if (!chatInput.value.trim()) return;

                countdownSeconds = COUNTDOWN_DURATION;
                const countdownNumber = countdownBadge.querySelector('.voice-countdown-number');
                countdownNumber.textContent = countdownSeconds;
                countdownBadge.style.display = 'flex';
                countdownBadge.offsetHeight; // Force reflow
                countdownBadge.classList.add('active');

                countdownInterval = setInterval(function () {
                    countdownSeconds--;
                    countdownNumber.textContent = countdownSeconds;
                    if (countdownSeconds <= 0) {
                        clearInterval(countdownInterval);
                        countdownInterval = null;
                    }
                }, 1000);

                autoSendTimer = setTimeout(function () {
                    countdownBadge.style.display = 'none';
                    countdownBadge.classList.remove('active');
                    autoSendTimer = null;
                    if (chatInput.value.trim()) {
                        chatForm.dispatchEvent(new Event('submit'));
                    }
                }, COUNTDOWN_DURATION * 1000);
            }

            function setListeningState(listening) {
                isListening = listening;
                if (listening) {
                    cancelAutoSend();
                    clearSilenceTimer();
                    btnVoice.classList.add('listening');
                    iconMic.style.display = 'none';
                    iconStop.style.display = 'block';
                    chatInput.placeholder = '🎙️ Mendengarkan... bicara sekarang';
                } else {
                    btnVoice.classList.remove('listening');
                    iconMic.style.display = 'block';
                    iconStop.style.display = 'none';
                    chatInput.placeholder = 'Tanyakan sesuatu...';
                    clearSilenceTimer();
                }
            }

            // Cancel auto-send when user edits
            chatInput.addEventListener('focus', function () {
                if (autoSendTimer) cancelAutoSend();
            });
            chatInput.addEventListener('input', function () {
                if (autoSendTimer) cancelAutoSend();
            });
            countdownBadge.addEventListener('click', function () {
                cancelAutoSend();
                chatInput.focus();
            });

            btnVoice.addEventListener('click', function () {
                if (isListening) {
                    clearSilenceTimer();
                    recognition.stop();
                } else {
                    cancelAutoSend();
                    finalTranscript = chatInput.value;
                    interimTranscript = '';
                    try {
                        recognition.start();
                    } catch (e) { /* Already started */ }
                }
            });

            recognition.addEventListener('start', function () {
                setListeningState(true);
            });

            // Helper to fix common misheard internal terms
            function normalizeTranscript(text) {
                if (!text) return text;
                return text
                    .replace(/\b(lok\s*sit|log\s*sit|lok\s*shit|blok\s*sit|lock\s*sheet|log\s*sheet|loxit|loksit)\b/gi, 'logsheet')
                    .replace(/\b(j t m|je te em|je te m)\b/gi, 'JTM')
                    .replace(/\b(u l p|u el pe)\b/gi, 'ULP')
                    .replace(/\b(u p tiga|u pe tiga|up tiga)\b/gi, 'UP3');
            }

            recognition.addEventListener('result', function (event) {
                interimTranscript = '';
                for (let i = event.resultIndex; i < event.results.length; i++) {
                    let transcript = event.results[i][0].transcript;
                    transcript = normalizeTranscript(transcript);
                    
                    if (event.results[i].isFinal) {
                        finalTranscript += (finalTranscript ? ' ' : '') + transcript;
                        // Got final result — start silence detection
                        resetSilenceTimer();
                    } else {
                        interimTranscript += transcript;
                        // Still receiving interim results — clear silence timer
                        clearSilenceTimer();
                    }
                }
                chatInput.value = finalTranscript + (interimTranscript ? ' ' + interimTranscript : '');
                chatInput.style.height = 'auto';
                const maxH = 160;
                chatInput.style.height = (chatInput.scrollHeight < maxH ? chatInput.scrollHeight : maxH) + 'px';
            });

            recognition.addEventListener('speechend', function () {
                // Browser detected user stopped speaking
                // Start silence timer as fallback
                resetSilenceTimer();
            });

            recognition.addEventListener('end', function () {
                setListeningState(false);
                clearSilenceTimer();
                chatInput.value = finalTranscript.trim();
                if (chatInput.value) {
                    startAutoSendCountdown();
                }
            });

            recognition.addEventListener('error', function (event) {
                setListeningState(false);
                clearSilenceTimer();
                cancelAutoSend();
                if (event.error === 'not-allowed') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Akses Mikrofon Ditolak',
                        text: 'Izinkan akses mikrofon di browser Anda untuk menggunakan fitur input suara.',
                        confirmButtonColor: '#10a37f',
                        confirmButtonText: 'Mengerti'
                    });
                } else if (event.error !== 'aborted') {
                    console.error('Speech recognition error:', event.error);
                }
            });
        } else {
            btnVoice.addEventListener('click', function () {
                Swal.fire({
                    icon: 'info',
                    title: 'Fitur Tidak Didukung',
                    text: 'Browser Anda tidak mendukung fitur input suara. Gunakan Google Chrome atau Microsoft Edge untuk fitur ini.',
                    confirmButtonColor: '#10a37f',
                    confirmButtonText: 'Mengerti'
                });
            });
        }
    }

    // ── Initial State ───────────────────────────────────────────────────
    if (activeModelIndicator) {
        activeModelIndicator.innerHTML = '<span class="chat-status-dot"></span> Ready';
    }
    chatInput.focus();
}
